<template>
  <v-layout
    v-if="notificacao.Descricao"
    class="border-bottom"
    :class="{ 'mt-1': $vuetify.breakpoint.smAndDown }"
    :column="$vuetify.breakpoint.smAndDown"
    :align-center="$vuetify.breakpoint.mdAndUp"
  >
    <v-flex xs12 md10>
      <div class="px-3" :class="{ 'px-4': $vuetify.breakpoint.mdAndUp }">
        <v-icon small class="mr-1">{{ iconNotificacao }}</v-icon>{{ notificacao.Descricao }}
      </div>
    </v-flex>
    <v-flex xs12 md2 pr-3 :pr-4="$vuetify.breakpoint.mdAndUp">
      <v-layout align-center>
        <span class="ml-3 caption">{{ moment(notificacao.DataNotificacao).from() }}</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn @click="marcaLida(notificacao)" flat icon small v-on="on">
              <v-icon 
                :color="colorIconStatusNotificacao(notificacao.Status)"
              >
                {{ iconStatusNotificacao(notificacao.Status) }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ tipText(notificacao.Status) }}</span>
        </v-tooltip>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Notificacao from '@/domain/notificacao/Notificacao';

export default {
  name: 'NotificacaoItem',
  props: {
    notificacao: {
      type: Object,
      default: () => new Notificacao()
    }
  },
  computed: {
    iconNotificacao() {
      const notificacaoLog = {
        'iniciou a execução da atividade.': 'play_arrow',
        'parou de executar a atividade.': 'pause',
        'finalizou a atividade.': 'done',
        'excluiu essa atividade.': 'delete',
        'alterou a situação para': 'description',
        'alterou a previsão para': 'event',
        'alterou o responsável para': 'people_alt',
        'adicionou o colaborador': 'person_add',
        'removeu você da atividade.': 'person_remove',
        'removeu o colaborador': 'person_remove',
        'concluiu o checklist': 'check_box',
        'marcou o checklist': 'check_box_outline_blank',
        'vinculou essa atividade no projeto': 'attachment',
        'removeu essa atividade do projeto': 'attachment',
        'vinculou essa atividade na atividade': 'attachment',
        'removeu essa atividade da atividade': 'attachment',
        'alterou o workflow para': 'timeline',
        'removeu o workflow.': 'timeline',
        'alterou a descrição para': 'folder',
        'alterou as observações.': 'message'
      };
      const descricaoNotificacao = this.notificacao.Descricao ? this.notificacao.Descricao.split(':').splice(1,1).join('').trim() : '';
      return notificacaoLog[descricaoNotificacao] || 'comment';
    }
  },
  methods: {
    ...mapActions(['marcaNotificacaoLida']),
    ...mapMutations(['showNotification', 'closeNotification']),
    iconStatusNotificacao(status) {
      return status.trim() == 'P' ? 'radio_button_unchecked' : 'check_circle';
    },
    colorIconStatusNotificacao(status) {
      return status.trim() == 'P' ? 'default' : 'success';
    },
    async marcaLida(notificacao) {
      notificacao.Status.trim() == 'P' ? 
      notificacao.Status = 'F' : 
      notificacao.Status = 'P';
      await this.marcaNotificacaoLida(notificacao);
      this.showNotification({ text: `Notificação marcada como: ${notificacao.Status.trim() == 'F' ? 'Lida' : 'Não Lida'}`, status: 'success' });
    },
    tipText(status) {
      return status.trim() == 'P' ? 'Marcar como lida' : 'Marcar como não lida';
    },
    autorNotificacao(notificacao) {
      return notificacao.split(' ')[0];
    }
  }
}
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #ddd;
}
.border-bottom:last-child {
  border-bottom: none;
}
</style>